/*
Loads Cloudflare's Turnstile script once, however many widgets ask for it.

The script is added from code, so it loads asynchronously; Turnstile only
supports that with ?render=explicit and an onload callback (turnstile.ready()
doesn't work here). A failed load is forgotten so a later call can retry.
*/

const ONLOAD = "__traveljabTurnstileOnload";
const SRC = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=${ONLOAD}`;

let loading = null;

export function loadTurnstile() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (loading) {
    return loading;
  }

  loading = new Promise((resolve, reject) => {
    window[ONLOAD] = () => resolve(window.turnstile);

    const script = document.createElement("script");
    script.src = SRC;
    script.async = true;
    script.onerror = () => {
      loading = null;
      script.remove();
      reject(new Error("Turnstile failed to load"));
    };
    document.head.appendChild(script);
  });

  return loading;
}
